export const Roles = {
    ADMIN : 'Admin',
    WARRANTY_TEAM: 'WarrantyTeam',
    WARRANTY_MANAGER: 'WarrantyManager',
    SSH_MANAGER: 'SSHManager',
    SSH_DIRECTOR: 'SSHDirector',
    SSH_GENERAL_MANAGER: 'SSHGeneralManager',
    CEO: 'CEO',
    DEALER: 'Dealer',
    SERVICE_DEALER: 'ServiceDealer',
    SALES_DEALER: 'SalesDealer',
    VEHICLE_SALES_DEALER: 'VehicleSalesDealer',
    TECHNICAL_SUPPORT_USER: 'TechnicalSupportUser',
    PART_TEAM: 'PartTeam',
    VEHICLE_SALES_MANAGER: 'VehicleSalesManager',
    WARRANTY_QUALITY_OFFICER: 'WarrantyQualityOfficer',
    KARSAN_LOGISTICS: 'KarsanLogistics',
    REGIONAL_MANAGER: 'RegionalManager',
    KARSAN_SSH: 'KarsanSSH',
    ACCOUNTING: 'Accounting',
    APPLICATION_MANAGER: 'ApplicationManager',
    SERVICE_BULLETIN_USER: 'ServiceBulletinUser',
    FINANCE_TEAM: 'FinanceTeam'
};

export const RoleList = Object.values(Roles);
